import { createSlice } from "@reduxjs/toolkit";

const otherSlice = createSlice({
  name: "otherSlice",
  initialState: {
    valid: false,
    errorMessage: '',
    orderFilterData: {},
    refetchData: false,
    hiddenOrderSave: false,
    companyRedux: [],
    ndaRedux: [],
    ndaCheckbox: {},
    createSup: false,
    reviseSup: false,
    readSup: false,
    reviseIsUpdate: false,
    reviseSupId: 0,
    loadingSubmitAndCreate: false,
    supNextButtonLoading: true,
    individualBool: false,
  },
  reducers: {
    updateValid: (state, action) => { state.valid = action.payload },
    updateErrorMessage: (state, action) => { state.errorMessage = action.payload },
    updateOrderFilterData: (state, action) => { state.orderFilterData = action.payload },
    updateRefetchData: (state) => { state.refetchData = !state.refetchData },
    updateHiddenOrderSave: (state, action) => { state.hiddenOrderSave = action.payload },
    updateCompanyInformationData: (state, action) => { state.companyRedux = action.payload },
    updateNdaData: (state, action) => { state.ndaRedux = action.payload },
    updateSupNextButtonLoading: (state, action) => { state.supNextButtonLoading = action.payload },
    onCreateSup: (state) => {
      state.createSup = true
    },
    onIndividual: (state, action) => {
      state.individualBool = action.payload
    },
    offCreateSup: (state) => {
      state.createSup = false
    },
    onReviseSup: (state) => {
      state.reviseSup = true
    },
    offReviseSup: (state) => {
      state.reviseSup = false
    },
    updateReviseId: (state, action) => {
      state.reviseSupId = action.payload
    },
    updateReviseIsUpdate: (state, action) => {
      state.reviseIsUpdate = action.payload
    },
    onReadSup: (state) => {
      state.readSup = true
    },
    offReadSup: (state) => {
      state.readSup = false
    },
    updateLoadingSubmitAndCreate: (state) => {
      state.loadingSubmitAndCreate = state
    },
  },
});

export const { updateReviseIsUpdate, updateValid, updateErrorMessage, updateOrderFilterData, updateRefetchData, onCreateSup, offCreateSup,
  updateHiddenOrderSave, updateCompanyInformationData, updateNdaData, onReviseSup, offReviseSup,
  updateReviseId, onReadSup, offReadSup, updateLoadingSubmitAndCreate, updateSupNextButtonLoading, onIndividual } = otherSlice.actions;

export const otherReducer = otherSlice.reducer;
